import type { ReactNode } from "react";
import { CoreChatComponent, useChatStyles } from "@b2bportal/core-chat";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@b2bportal/core-ui";
import clsx from "clsx";

import defaultStyles from "./ContactSupportOption.module.scss";

export interface IContactSupportOptionProps {
  className?: string;
  disabled?: boolean;
  icon: IconNameEnum;
  onClick: () => void;
  subtitles: ReactNode | ReactNode[];
  title: ReactNode;
}

export const ContactSupportOption = (props: IContactSupportOptionProps) => {
  const {
    className,
    disabled = false,
    icon,
    onClick,
    subtitles,
    title,
  } = props;
  const COMPONENT_KEY = CoreChatComponent.ContactSupportOption;
  const styles = useChatStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <button
      className={clsx(block, className)}
      disabled={disabled}
      onClick={onClick}
    >
      <div className={cn("option-icon-container", ["type"])}>
        <Icon className={cn("option-icon", ["type"])} iconName={icon} />
      </div>
      <div className={cn("option-details")}>
        <span className={cn("option-title")}>{title}</span>
        <span className={cn("option-subtitle")}>{subtitles}</span>
      </div>
      <div className={cn("option-icon-container", ["action"])}>
        <Icon
          className={cn("option-icon", ["action"])}
          iconName={IconNameEnum.chevronRight}
        />
      </div>
    </button>
  );
};
